import React from 'react';
import PropTypes from 'prop-types';
import { CardContent as MuiCardContent } from '@material-ui/core';

const propTypes = {
  children: PropTypes.node.isRequired,
};

function CardContent({ children }) {
  return <MuiCardContent>{children}</MuiCardContent>;
}

CardContent.propTypes = propTypes;

export default CardContent;
